import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/geren.png'
import _imports_1 from '@/assets/icon/qiye.png'
import _imports_2 from '@/assets/icon/weirenzheng.png'


const _withScopeId = n => (_pushScopeId("data-v-7d91e3e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "information" }
const _hoisted_2 = { class: "one" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = {
  key: 0,
  class: "name"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_0,
  alt: ""
}
const _hoisted_6 = {
  key: 2,
  src: _imports_1,
  alt: ""
}
const _hoisted_7 = {
  key: 3,
  src: _imports_2,
  alt: ""
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "black" }, null, -1))
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 6,
  class: "novip"
}
const _hoisted_11 = { class: "two" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "公司名称:", -1))
const _hoisted_13 = { class: "three" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "职业:", -1))
const _hoisted_15 = { class: "three" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "常用软件:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.user.data.username), 1),
      (_ctx.user.data.username == null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.userinfot.mobile), 1))
        : _createCommentVNode("", true),
      (_ctx.user.data.company_id == null && _ctx.user.data.identification == 3)
        ? (_openBlock(), _createElementBlock("img", _hoisted_5))
        : _createCommentVNode("", true),
      (_ctx.user.data.company_id != null)
        ? (_openBlock(), _createElementBlock("img", _hoisted_6))
        : _createCommentVNode("", true),
      (_ctx.user.data.company_id == null && _ctx.user.data.identification != 3)
        ? (_openBlock(), _createElementBlock("img", _hoisted_7))
        : _createCommentVNode("", true),
      _hoisted_8,
      (_ctx.vipinfo.userimgurl)
        ? (_openBlock(), _createElementBlock("img", {
            key: 4,
            src: _ctx.vipinfo.userimgurl,
            alt: ""
          }, null, 8, _hoisted_9))
        : _createCommentVNode("", true),
      (_ctx.isVip)
        ? (_openBlock(), _createElementBlock("p", {
            key: 5,
            class: "vip-title",
            style: _normalizeStyle({ color: _ctx.vipinfo.usercolor })
          }, _toDisplayString(_ctx.vipinfo.title), 5))
        : _createCommentVNode("", true),
      (!_ctx.isVip)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, "开通会员全场商品八折优惠"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("p", null, _toDisplayString(_ctx.user.data.company ? _ctx.user.data.company : "未填写"), 1)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("p", null, _toDisplayString(_ctx.user.data.vocation), 1)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _hoisted_16,
      _createElementVNode("p", null, _toDisplayString(_ctx.user.data.software), 1)
    ])
  ]))
}